<template>
    <div :style="{width: changeHeight + 'px', height: changeHeight + 'px'}" style="display: grid; grid-template-columns: 1fr 1fr; place-items:center; margin: 0 auto; border: 1px solid #d9d9d9; overflow: hidden; border-radius: 50%; background-color: #f5f5f5;">
        <div :style="roundBorder(i)" style="overflow: hidden; display: flex; justify-content: center; align-items: center;" v-for="each, i in 4" :key="i">
            <img v-if="memberList[i]" :style="{width: changeWidth / 2 + 'px', height: changeHeight / 2 + 'px'}" style="object-fit: cover;" :src="getImagePath(i)" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'RoundProfileImage',
    props: {
        memberList: {
            type: [Array, String],
            default: () => { }
        },
        changeWidth: {
            type: Number,
            default: 80
        },
        changeHeight: {
            type: Number,
            default: 80
        }
    },
    methods: {
        roundBorder(i) {
            if (i === 0) {
                return { borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9', width: this.changeWidth / 2 + 'px', height: this.changeHeight / 2 + 'px'}
            }

            if (i === 1) {
                return { borderBottom: '1px solid #d9d9d9', width: this.changeWidth / 2 + 'px', height: this.changeHeight / 2 + 'px' }
            }

            if (i === 2) {
                return { borderRight: '1px solid #d9d9d9', width: this.changeWidth / 2 + 'px', height: this.changeHeight / 2 + 'px' }
            }

            return { border: 'none', width: this.changeWidth / 2 + 'px', height: this.changeHeight / 2 + 'px' }
        },
        getImagePath(i) {
            if (this.memberList[i] && this.memberList.image_path) {
                return this.$resourcePath + this.memberList[i].image_path
            } else {
                return this.$resourcePath + this.memberList[i]
            }
        },
    }
}
</script>

<style scoped></style>